<template>
	<div class="site-backups-list-wrapper">
		<ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
			<li class="nav-item">
				<a :class="{'nav-link': true, 'active': currentTab === 'daily'}" data-toggle="tab" href="#daily" @click="changeTab('daily')">
					Daily <!--<span v-if="backups.daily.length">({{backups.daily.length}})</span>-->
				</a>
			</li>
			<!--<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#hourly">
					Hourly
				</a>
			</li>-->
			<li class="nav-item">
				<a :class="{'nav-link': true, 'active': currentTab === 'manual'}" data-toggle="tab" href="#manual" @click="changeTab('manual')">
					Manual
				</a>
			</li>
		</ul>
		<div class="tab-content tab-space tab-subcategories">
			<!-- Panel for the Daily automatic backups - START -->
			<div :class="{'tab-pane': true, 'active': currentTab === 'daily'}" id="daily">
				<div class="card" v-if="loading === false">
					<div class="loader"></div>
				</div>
				<div class="card" v-else>
					<div class="card-header">
						<div>
							We automatically backup your site every day.
						</div>
						<div>
							Each daily backup will be stored for 30 days.
						</div>
					</div>
					<div class="card-body" style="margin-top: 10px">
						<div class="table-responsive">
							<table class="table daily_backup" v-if="backups.daily.length > 0">
								<thead class="text-primary">
									<tr>
										<th width="80%">Created (CST)</th>
										<th class="text-center">Restore</th>
										<th class="text-center">Download</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="backup in backups.daily" :key="backup.value">
										<td>{{backup.label}}</td>
										<td class="text-center">
											<div class="loader small_loader" v-if="backup.value === actionValue"></div>
											<button v-else :disabled="actionValue !== '' || !backup.completed" class="btn btn-outline-primary btn-round btn-sm" type="button" @click.prevent="backupQueueRequest('restore', backup.value, 'back')">
												Restore
											</button>
										</td>
										<td class="text-center">
											<div class="loader small_loader" v-if="backup.value === actionValue"></div>
											<button v-else :disabled="actionValue !== '' || !backup.completed" class="btn btn-outline-primary btn-round btn-sm" type="button" @click.prevent="backupQueueRequest('download', backup.value, 'back')">
												Download
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<!-- Panel for the Daily automatic backups - END -->
			<!-- Panel for the Manual backups - START -->
			<div :class="{'tab-pane': true, 'active': currentTab === 'manual'}" id="manual">
				<div class="card" v-if="loading === false">
					<div class="loader"></div>
				</div>
				<div v-else>
					<form @submit.prevent="backupQueueRequest('create', null, 'manual')">
						<div class="row">
							<div class="col-sm-12 col-md-6 mb-6">
								<div class="form-group">
									<label for="ticketBody">
										Notes
										<i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Backup notes are limited to 50 characters."></i>
									</label>
									<input :style="(disableInput) ? 'background:#CCCCCC' : ''" :disabled="disableInput" class="form-control" id="ticketBody" maxlength="50" v-model.trim="message"/>
								</div>
							</div>
							<div class="col-sm-12 col-md-6 mb-6 d-flex align-items-end">
								<button type="submit" :disabled="actionValue!=''" class="btn btn-primary btn-sm w-100 align-middle backup-now-button">
									<i class="fa fa-paper-plane" aria-hidden="true"></i> Backup now
								</button>
							</div>
						</div>
					</form>
					<div class="card">
						<div class="card-body">
							<div class="table-responsive">
								<table class="table manual_backup" v-if="backups.manual.length > 0">
									<thead class="text-primary">
										<tr>
											<th width="30%">Created (CST)</th>
											<th width="37%">Note</th>
											<th class="text-center">
												Options
											</th>
											<th class="text-center">
												<i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Your most recent manual backup cannot be deleted"></i>
											</th>
											<th class="text-center">
												Download
											</th>
										</tr>
									</thead>
									<tbody>
									<tr v-for="(backup, index) in backups.manual" :key="backup.value">
										<td>{{ backup.label }}</td>
										<td v-if="manualBackupMessages[backup.value]">{{manualBackupMessages[backup.value].message }}
										</td>
										<td v-else></td>
										<td class="text-center">
											<div class="loader small_loader" v-if="backup.value == actionValue && actionType == 'restore'"></div>
											<button v-else :disabled="actionValue!=''" class="btn btn-outline-primary btn-round btn-sm btn-primary" type="button" @click.prevent="backupQueueRequest('restore', backup.value, 'manual')">
												Restore
											</button>
										</td>
										<td class="text-center">
											<div class="loader small_loader" v-if="backup.value == actionValue && actionType == 'delete'"></div>
											<div v-else>
												<button v-if="index !== 0" :disabled="actionValue!='' || backup.disabled" class="btn btn-outline-primary btn-round btn-sm btn-primary" type="button" @click.prevent="backupQueueRequest('delete', backup.value, 'manual')">
													Delete
												</button>
											</div>
										</td>
										<td class="text-center">
											<div class="loader small_loader" v-if="backup.value === actionValue && actionType === 'download'"></div>
											<button v-else :disabled="actionValue !== ''" class="btn btn-outline-primary btn-round btn-sm btn-primary" type="button" @click.prevent="backupQueueRequest('download', backup.value, 'manual')">
												Download
											</button>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Panel for the Manual backups - END -->
			<!-- Panel for the automatic system generated backups - START -->
			<div class="tab-pane" id="hourly">

			</div>
			<!-- Panel for the automatic system generated backups - END -->
		</div>
	</div>
</template>


<script>
	import moment from "moment-timezone"
	import _ from "lodash"
	import swal from "sweetalert2"
	import {db} from "@/firebase/init"
	import refreshToken from "../../../mixins/refreshTokenMixin"

	export default {
		name: "BackupList",
		mixins: [refreshToken],
		props: {
			account: {
				type: Object,
				required: true
			},
			envType: {
				type: String,
				required: true
			},
			fromCollaborator: {
				type: Boolean,
				required: false
			},
			supervisor: {
				type: Object,
				required: false
			}
		},
		data: function () {
			return {
				domain: '',
				backups: {
					daily: [],
					manual: []
				},
				manualBackupMessages: [],
				loading: false,
				message: '',
				// actionValue: '',
				// actionType: false,
				total_daily: 0,
				currentTab: 'daily'
				// disableInput: false
			}
		},
		computed: {
			actionValue() {
				if(this.$store.getters.actionValue === ''){
					this.listBackups('manual');
				}
				return this.$store.getters.actionValue;
			},
			actionType() {
				return this.$store.getters.actionType;
			},
			disableInput() {
				return this.$store.getters.disableInput;
			},
			accounts() {
				return this.$store.getters["hosting/accounts"];
			},
			clientID() {
				return this.$store.getters.getCustomerID;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			user() {
				return this.$store.getters.user;
			},
			requestUserId(){
				return this.$store.getters.requestUserId;
			},
			UID(){
				return this.$store.getters.getUID;
			}
		},
		watch: {
			account(value) {
				console.log(value);
				if (this.envType === 'staging') {
					this.domain = value.staging.domain
				} else {
					this.domain = value.domain
				}
				this.listBackups('daily');
				this.listBackups('manual');
			},
			envType(value) {
				if (value === 'staging') {
					this.domain = this.account.staging.domain
				} else {
					this.domain = this.account.domain
				}
				this.listBackups('daily');
				this.listBackups('manual');
			}
		},
		methods: {
			async listBackups(type) {
				if(!this.account.ftp.host){
					this.loading = true;
					return false;
				}
				this.loading = false;
				let domain;
				if (this.envType === 'staging') {
					domain = this.account.staging.domain
				} else {
					domain = this.account.domain
				}
				this.$http.post('backup', {
					ip: this.account.ftp.host,
					domain: domain,
					grant_type: "token",
					token: this.userToken,
					type: type
				})
					.then(async (response) => {
						let data = response.data.data;
						if (type === 'manual') {
							this.manualBackupMessages = [];
							let manualBackupMessages = [];

							if (this.envType === 'staging' && this.account.staging.manualBackups !== undefined) {
                                const customerUID = (this.fromCollaborator) ? this.supervisor.supervisorId : this.UID;
								manualBackupMessages = await this.$store.dispatch('hosting/fetchBackupsOfDomain', {
                                    UID: customerUID, domain: this.account.staging.domain
								})// this.account.staging.manualBackups
							} else if (this.envType === 'live' && this.account.manualBackups !== undefined) {
                                const customerUID = (this.fromCollaborator) ? this.supervisor.supervisorId : this.UID;
								manualBackupMessages = await this.$store.dispatch('hosting/fetchBackupsOfDomain', {
                                    UID: customerUID, domain: this.account.domain
								})//this.account.manualBackups
							}
							if (manualBackupMessages.length > 0) {
								manualBackupMessages.map((item) => {
									this.manualBackupMessages[item.folder] = item;
								})
							}
						}

						let backups = data.reverse(); //data.reverse().slice(0, 30);
						backups = backups.map(item => {
						  let backupDate = null
						  let completed = true
              const parsedArray = item.split("_")
						  if (parsedArray.length > 1) {
                backupDate = parsedArray[1]
                completed = false
              } else {
                backupDate = item
              }
              const deletedBackups = JSON.parse(this.$cookie.get('deleted-backup')) || []
							return {
								label: moment(backupDate).format('MMM Do, YYYY, hh:mm:ss A'),
								value: item,
                completed,
                disabled: deletedBackups.includes(item)
							};
						});
						this.backups[type] = backups;
						console.log(this.backups['manual']);
					})
					.catch((err) => {
						this.backups[type] = [];
						if (err.response.status === 401 && this.countRequests < 1) {
							this.refreshToken(() => {
								this.listBackups(type)
							})
						}
					}).finally(() => {
						this.loading = true;
						this.countRequests++

					})
			},
			createBackup() {
				//TODO:: set portal limit for account
				let message = this.message
				if (this.backups.manual.length > 4) {
					swal({
						title: "Limit backups!",
						text: "You are limited to 5 manual backups. Please delete one.",
						type: "error",
					});
					return false
				}
				let date = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss');
				let folderName = date.replace(/:/g, '_').replace(' ', 'T')

				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to create a backup for ${this.domain}.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.disableInput = true;
							this.backups.manual.unshift({
								label: moment(date).format('MMM Do, YYYY, hh:mm:ss A'),
								value: date
							});
							// this.actionValue = date;
							// this.actionType = "restore";
							this.$http.post('backup/create', {
								ip: this.account.ftp.host,
								domain: this.domain,
								grant_type: "token",
								token: this.userToken,
								backup_name: 'manual-' + folderName
							})
								.then((response) => {
									swal({
										title: "Success!",
										html: response.data.message,
										type: "success"
									})
									this.addLog({
                    primaryPlan : this.account.domain,
										name: this.user.firstName + " " + this.user.lastName,
										message: "Created backup manual-" + folderName,
										level: "info"
									})
									if (message) {
										console.log('Message Here...', message);
										this.addBackupMessageAccounts({
											message: message.substr(0, 51),
											folder: date
										})
										this.message = ''
									} else {
										this.listBackups('manual')
									}
								})
								.catch((err) => {
									console.log(err);
									let responseMessage = err.response.data.message;
									if (err.response.status === 422) {
										responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
									} else if (err.response.status === 401) {
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}

									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									})

									this.backups.manual = this.backups.manual.filter(item => {
										return !(item.label == moment(date).format('MMM Do, YYYY, hh:mm:ss A') && item.value == date);
									});

									/*
									this.addLog({
										name: this.user.firstName + " " + this.user.lastName,
										message: "Error create backup. Message: " + err.response.data.message,
										level: "danger"
									})
									*/
								}).finally(() => {
								// this.disableInput = false;
								// this.actionValue = '';
								// this.actionType = '';
							})
						}
					})
			},
			restoreBackup(type, date) {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to restore from the selected backup. This is not reversible, you may only restore from another backup.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							let message = setInterval(() => {
								swal({
									title: "Message!",
									html: "Don't worry, restore still in progress and will finish soon.",
									type: "info",
									showCancelButton: false,
									showConfirmButton: true,
									confirmButtonText: "OK",
								})
							}, 30000);
							this.actionValue = date;
							this.actionType = 'restore';
							this.$http.post('backup/restore', {
									ip: this.account.ftp.host,
									domain: this.domain,
									grant_type: "token",
									token: this.userToken,
									backup_name: type + '-' + date.replace(/:/g, '_').replace(' ', 'T')
								},
								{
									timeout: 5*60*1000
								})
								.then((response) => {
									swal({
										title: "Success!",
										html: response.data.message,
										type: "success"
									})
									this.addLog({
                    primaryPlan: 'Account Based Operation',
										name: this.user.firstName + " " + this.user.lastName,
										message: "Restore backup " + type + '-' + date.replace(/:/g, '_').replace(' ', 'T'),
										level: "info"
									})
								})
								.catch((err) => {
									let responseMessage = '';
									if (err.response) {
										responseMessage = err.response.data.message;
										if (err.response.status === 422) {
											responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
										} else if (err.response.status === 401) {
											responseMessage = "You need update token. Please Try Again!";
											this.refreshToken();
										}
									} else if (err.request) {
										responseMessage = err.request.message ? err.request.message : "Error response from server";
									} else {
										responseMessage = err.message;
									}
									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});

									if(err.status >= 500 || err.status === 404){
										this.addLog({
											name: this.user.firstName + " " + this.user.lastName,
											message: `Error restore backup. Message: ${responseMessage} Code: ${err.status}`,
											level: "danger"
										})
									}
								})
								.finally(() => {
									clearTimeout(message);
									this.actionValue = '';
									this.actionType = false;
								})
						}
					})
			},
			deleteBackup(type, date) {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to delete the selected backup. `,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.actionValue = date;
							this.actionType = 'delete';
							let backup_name = type + '-' + date.replace(/:/g, '_').replace(' ', 'T')
							this.$http.post('backup/delete', {
								ip: this.account.ftp.host,
								domain: this.domain,
								grant_type: "token",
								token: this.userToken,
								backup_name: backup_name
							})
								.then(() => {
									this.deleteBackupMessageFromAccount(date)
									swal({
										title: "Success!",
										html: "Your backup has been deleted!",
										type: "success"
									})
									this.addLog({
                    primaryPlan: 'Account Based Operation',
										name: this.user.firstName + " " + this.user.lastName,
										message: "Deleted backup " + backup_name,
										level: "info"
									})
								})
								.catch((err) => {
									let responseMessage = err.response.data.message;
									if (err.response.status === 422) {
										responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
									} else if (err.response.status === 401) {
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}

									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									})
									/*
									this.addLog({
										name: this.user.firstName + " " + this.user.lastName,
										message: "Error delete backup. Message: " + err.response.data.message,
										level: "danger"
									})
									*/
								}).finally(() => {
								this.actionValue = '';
								this.actionType = false;
							});
						}
					})
			},
			backupQueueRequest(operation, selectedBackupDate, type){
				if(operation === 'create'){
					if (this.backups.manual.length > 4) {
						swal({
							title: "Limit backups!",
							text: "You are limited to 5 manual backups. Please delete one.",
							type: "error",
						});
						return false
					}
					let date = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss');
					let folderName = date.replace(/:/g, '_').replace(' ', 'T')
					swal({
						title: "Are you sure?",
						text: `Please confirm that you would like to create a backup for ${this.domain}.`,
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then(result => {
						if(result.value){
							this.$store.commit('updateBackupActions', {
								value: date,
								type: 'restore',
								input: true
							});
							this.backups.manual.unshift({
								label: moment(date).format('MMM Do, YYYY, hh:mm:ss A'),
								value: date
							});
							this.requestToQueue(date, 'manual-' + folderName, operation, this.message);
						}
					})
				}else if(operation === 'restore'){
					swal({
						title: "Are you sure?",
						text: `Please confirm that you would like to restore from the selected backup. This is not reversible, you may only restore from another backup.`,
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then(result => {
						if(result.value){
							this.$store.commit('updateBackupActions', {
								value: selectedBackupDate,
								type: 'restore',
								input: true
							});
							this.requestToQueue(selectedBackupDate, type + '-' + selectedBackupDate.replace(/:/g, '_').replace(' ', 'T'), operation, null);
						}
					});
				}else if(operation === 'download'){
					swal({
						title: "Are you sure?",
            html: `Please note, only 1 download link can be requested per hour. Depending on the size of the backup, this request can take anywhere from a few minutes to several hours.<br>Would you like to proceed?`,
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then(result => {
						if(result.value){
							this.$store.commit('updateBackupActions', {
								value: selectedBackupDate,
								type: 'download',
								input: true
							});
							this.requestToQueue(selectedBackupDate, type + '-' + selectedBackupDate.replace(/:/g, '_').replace(' ', 'T'), operation, null);
						}
					});
				}else{
					swal({
						title: "Are you sure?",
						text: `Please confirm that you would like to delete the selected backup. `,
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then(result => {
						if(result.value){
							this.$store.commit('updateBackupActions', {
								value: selectedBackupDate,
								type: 'delete',
								input: true
							});
              const deletedBackups = JSON.parse(this.$cookie.get('deleted-backup')) || []
              deletedBackups.push(selectedBackupDate)
              this.$cookie.set('deleted-backup', JSON.stringify(deletedBackups), { expires: '2h' });
							this.requestToQueue(selectedBackupDate, type + '-' + selectedBackupDate.replace(/:/g, '_').replace(' ', 'T'), operation, null);
						}
					})
				}
			},
			requestToQueue(backupDate, backupName, operation, notes){
				this.$http.post('backup/queue', {
					ip: this.account.ftp.host,
					domain: this.domain,
					grant_type: "token",
					token: this.userToken,
					firstName: (!this.fromCollaborator) ? this.user.firstName : this.supervisor.supervisorName,
					lastName: (!this.fromCollaborator) ? this.user.firstName : this.supervisor.supervisorName,
					email: (!this.fromCollaborator) ? this.user.email : this.supervisor.supervisorEmail,
					UID: (!this.fromCollaborator) ? this.UID : this.supervisor.supervisorId,
					backupName: backupName,
					backupDate: backupDate,
					operation: operation,
					backupNotes: notes,
					envType: this.envType,
					collaborator: (!this.fromCollaborator) ? '0' : '1',
					collaboratorUID: this.UID,
					collaboratorEmail: this.user.email
				}).then((response) => {
					this.$notify({
						group: 'foo',
						title: 'Backup Request',
						duration: 3000,
						text: response.data.msg,
						type:  'info'
					});
					if(operation === 'download'){
						swal('Request Received!', 'You will soon receive an email with a link to your requested backup.', 'success');
					} else if(operation === 'delete'){ //pushing to account
						this.deleteBackupMessageFromAccount(backupDate)
					}
				}).catch((err) => {
					let msg = 'Error in initiating request for backup. Contact support!';
					if(err.response.status === 422){
						msg = err.response.data.msg;
					}
					this.$notify({
						group: 'foo',
						title: 'Backup Request',
						duration: 4000,
						text: msg,
						type:  'error'
					});
					this.$store.commit('updateBackupActions', {
						value: '',
						type: '',
						input: false
					});
				}).finally(() => {
					this.message = '';
				});
			},
			addBackupMessageAccounts(data) {
				let backup = {};
				backup.folder = data.folder;
				backup.message = data.message;

				let accounts = _.map(this.accounts, (account) => {
					if (this.account.type === 'Addon Domain') {
						let addon = account.addon;
						_.map(addon, (item) => {
							if (item.domain == this.domain) {
								if (this.envType === 'staging') {
									if (item.staging.manualBackups === undefined) {
										item.staging.manualBackups = []
									}
									item.staging.manualBackups.push(backup)
								} else {
									if (item.manualBackups === undefined) {
										item.manualBackups = []
									}
									item.manualBackups.push(backup)
								}
							}
							return item
						});
						account.addon = addon;
					} else {
						let primary = account.primary;
						if (this.envType === 'staging') {
							if (primary.staging.manualBackups === undefined) {
								primary.staging.manualBackups = []
							}
							primary.staging.manualBackups.push(backup)
						} else {
							if (primary.manualBackups === undefined) {
								primary.manualBackups = []
							}
							primary.manualBackups.push(backup)
						}
						account.primary = primary;
					}
					return account;
				});

				this.saveToDB(accounts);
			},
			deleteBackupMessageFromAccount(folder) {
				let accounts = _.map(this.accounts, (account) => {
					if (this.account.type === 'Addon Domain') {
						let addon = account.addon;
						addon.map((item) => {
							if (item.domain === this.domain) {
								if (this.envType === 'staging') {
									if (item.staging.manualBackups !== undefined) {
										item.staging.manualBackups = item.staging.manualBackups.filter((backup) => {
											return backup.folder != folder
										})
									}
								} else {
									if (item.manualBackups !== undefined) {
										item.manualBackups = item.manualBackups.filter((backup) => {
											return backup.folder != folder
										})
									}
								}
							}
							return item
						});
						account.addon = addon;
					} else {
						let primary = account.primary;
						if (this.envType === 'staging') {
							if (primary.staging.manualBackups !== undefined) {
								primary.staging.manualBackups = primary.staging.manualBackups.filter((backup) => {
									return backup.folder != folder
								})
							}
						} else {
							if (primary.manualBackups !== undefined) {
								primary.manualBackups = primary.manualBackups.filter((backup) => {
									return backup.folder != folder
								})
							}
						}
						account.primary = primary;
					}
					return account;
				});
				this.saveToDB(accounts)
			},
			changeTab(tab) {
				this.currentTab = tab;
			},
			saveToDB(accounts){
        this.addHostingAccountEventLog({hostingAccountId : this.requestUserId ,  afterPayload: accounts , beforePayload : false,  action: 'Save To DB' })
				db
					.collection("hostingAccounts")
					.doc(this.requestUserId)
					.set({
						accounts: accounts
					})
					.then(() => {
						this.listBackups('manual');
            this.addLog({
              primaryPlan: 'Account Based Operation',
              name: this.user.firstName + " " + this.user.lastName,
              message: "Backup list has been successfully updated",
              level: "info"
            });
					});
			}
		},
		beforeMount() {
      if (this.envType === 'staging') {
        this.domain = this.account.staging.domain
      } else {
        this.domain = this.account.domain
      }
			this.listBackups('daily')
			this.listBackups('manual')
		},
		mounted() {
			/* eslint-disable */
			$(function () {
				$('[data-toggle="tooltip"]').tooltip();
			});
			/* eslint-enable */
		},
		updated() {
			/* eslint-disable */
			$(function () {
				$('[data-toggle="tooltip"]').tooltip();
				$(".daily_backup").DataTable({ordering: false, destroy: true, searching: false, deferRender: true});
				// $(".manual_backup").DataTable({ordering: false, destroy: true, searching: false});
			});
			/* eslint-enable */
		}
	};
</script>

<style lang="scss">
	.fa-question-circle {
		font-size: 14px
	}

	.backup-now-button {
		height: 38px;
	}
</style>
